import * as React from "react";
export var Tooltip = function (props) { return (React.createElement("div", { className: "scl-a-tooltip__container" },
    React.createElement("div", { className: "scl-a-tooltip" },
        React.createElement("span", { className: "scl-a-tooltip--text" }, props.children)))); };
